import { browser } from '$app/environment'
import { generateId } from '$lib/factories'
import { messages } from '$lib/messages'
import { apiFetchJson, apiGetJson, apiPostJson } from '$lib/proxy/apiProxy'
import { CustomErrorMgr } from '$lib/types/custom_error'
import { DOC_TYPE } from '$lib/types/document'

import type { ExpensesParams } from '../expense/types'
import { expenses_store as store } from './expenses'
import { parseExpensesList } from './helper'


let controller: AbortController | null

export async function getExpensesList(params: ExpensesParams, setStore = true) {
	//console.log('expenses parameters', parameters);
	if (controller) {
		controller.abort()
	}
	controller = new AbortController()
	const signal = controller.signal

	// const parameters = qryParams
	const jsonData = await apiPostJson(
		'/expenses',
		params,
		signal
	)
	controller = null

	// Check if cancelled by AbortController
	if (jsonData === null) return null
	if (jsonData?.error) {
		return []
	}

	const data = parseExpensesList(jsonData)
	if (setStore) store.set(data)

	return data
}


export async function uploadExpensesFiles(newFiles: FileList) {
	if (!browser) return

	const maxBytes = 1048576 * 10 // 1MB = 1048576 / MAX 10MB
	let upload_limit_reached = false

	if (newFiles) {

		for (let i = 0; (i < newFiles.length && !upload_limit_reached); i++) {
			// Check attachment SIZE
			const newFile = newFiles[i]

			// console.log('File -> newFile.name', newFile.name)
			// console.log('File -> newFile.size: ', newFile.size)

			const maxMB = Math.round(maxBytes / 1024 / 1024)

			if (newFile.size > maxBytes) {
				messages.warning('File is too big. Please select a smaller one, max ' + maxMB + ' MB')
				break
			}

			let file_name = newFile.name
			// avoid image.jpg file name from take photo
			if (file_name === 'image.jpg') file_name = 'image-' + new Date().toISOString() + '.jpg'

			const data = new FormData()
			const doc_id = generateId()
			data.append('doc_type', DOC_TYPE.EXPENSES)
			data.append('doc_id', doc_id)
			data.append('file_name', file_name)
			data.append('file', newFile)

			// responses.push(uploadExpenseFile(data))
			// const jsonData = await uploadExpenseFile(data)
			const jsonData = await apiFetchJson(fetch, 'post', '/expenses/file/upload', undefined, data, undefined)

			if (jsonData) {
				if (CustomErrorMgr.HasErrorInfo(jsonData.error)) {

					if (CustomErrorMgr.IsWithID(
						jsonData.error,
						CustomErrorMgr.ErrorsID.Send_limit_reached)) {
						upload_limit_reached = true
					}

					if (CustomErrorMgr.IsWarning(jsonData.error)) {
						messages.warning(`${jsonData.error.message}`)
					} else {
						messages.error(
							`Error uploading expense: ${jsonData.error.message}`
						)
					}
					console.log('jsonData.error', jsonData.error)
					return jsonData.error
				}
			}
		}
	}
	return
}


export async function checkLimitReached() {
	if (!browser) return

	const jsonData = await apiGetJson('/expenses/limit_reached')

	// Check if cancelled by AbortController
	if (jsonData === null) return true
	if (jsonData?.error) {
		return true
	}
	return jsonData.limit_reached

}